import * as moment from "moment";

export const currentWeek = () => moment().startOf("isoWeek").toDate();
